import api from '@/services/Api'

export default{
  fetchContent (filesToFetch) {
    return api().post('/ftpfetchcontent', filesToFetch)
  },
  fetchOldContent (filesToFetch) {
    return api().post('/ftpfetcholdcontent', filesToFetch)
  },
  uploadImage (mediaBytes) {
    return api().post('/ftpuploadimage', mediaBytes)
  },
  createThumbnail (mediaBytes) {
    return api().post('/ftpcreatethumbnail', mediaBytes)
  },
  createVideoThumbnail (mediaBytes) {
    return api().post('/ftpcreatevideothumbnail', mediaBytes)
  },
  createThumbnailCultura (mediaBytes) {
    return api().post('/ftpcreatethumbnailtocultura', mediaBytes)
  },
  createVideoThumbnailToCultura (mediaBytes) {
    return api().post('/ftpcreatevideothumbnailtocultura', mediaBytes)
  },
  convertPDF (pdfData, config) {
    return api().post('/convertpdf', pdfData, config)
  },
  uploadMultiplePDF (data) {
    return api().post('/uploadmultiplepdf', data)
  },
  removeImage (filename) {
    return api().post('/ftpremoveimage', filename)
  },
  removeImageFromCultura (filename) {
    return api().post('/ftpremoveimagefromcultura', filename)
  },
  removeOldFile (paths) {
    return api().post('/ftpremoveoldfiles', paths)
  },
  suspendImage (file) {
    return api().post('/ftpsuspend', file)
  },
  startBroadcast (file) {
    return api().post('/ftpstartmedia', file)
  },
  uploadVideo (mediaBytes) {
    return api().post('/ftpuploadvideo', mediaBytes)
  },
  uploadVideoToCultura (mediaBytes) {
    return api().post('/ftpuploadvideotocultura', mediaBytes)
  },
  uploadLargeMedia (formdata, config) {
    return api().post('/uploadlargemedia', formdata, config)
  },
  uploadPixabayVideo (videoData) {
    return api().post('/videofrompixabay', videoData)
  },
  uploadPixabayVideoToCultura (videoData) {
    return api().post('/videofrompixabaytocultura', videoData)
  },
  uploadAnimation (animationData) {
    return api().post('/ftpgenerateanimation', animationData)
  },
  getScreens (filename) {
    return api().post('/getscreens', filename)
  },
  renameFile (filename) {
    return api().post('/renamefile', filename)
  },
  renameFileCultura (filename) {
    return api().post('/renamefilecultura', filename)
  },
  fetchBanner (site) {
    return api().post('/fetchbanners', site)
  },
  fetchContentByUser (user) {
    return api().post('/fetchcontentbyuser', user)
  },
  fetchContentByUserAndSite (user) {
    return api().post('/fetchcontentbyuserandsite', user)
  },
  uploadToCultura (groups) {
    return api().post('/uploadtocultura', groups)
  },
  uploadMultiplePDFToCultura (data) {
    return api().post('/uploadmultiplepdftocultura', data)
  },
  fetchPlaylistOrder (data) {
    return api().post('/fetchplaylistorder', data)
  },
  savePlaylistOrder (playlist) {
    return api().post('/saveplaylistorder', playlist)
  },
  savePlaylistOrderToCultura (playlist) {
    return api().post('/saveplaylistordertocultura', playlist)
  }
}
